module.exports = {
          srcSet: __webpack_public_path__ + "2b16a57ed66ed211560e3e93cc854cbc-453.png"+" 453w",
          images:[ {path: __webpack_public_path__ + "2b16a57ed66ed211560e3e93cc854cbc-453.png",width: 453,height: 112}],
          src: __webpack_public_path__ + "2b16a57ed66ed211560e3e93cc854cbc-453.png",
          toString:function(){return __webpack_public_path__ + "2b16a57ed66ed211560e3e93cc854cbc-453.png"},
          
          width: 453,
          height: 112
        }